import { render, staticRenderFns } from "./personageForget.vue?vue&type=template&id=cf88a85c&scoped=true&"
import script from "./personageForget.vue?vue&type=script&lang=js&"
export * from "./personageForget.vue?vue&type=script&lang=js&"
import style0 from "./personageForget.vue?vue&type=style&index=0&id=cf88a85c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf88a85c",
  null
  
)

export default component.exports